<template>
  <div class="page">
    <van-nav-bar title="我的价值榜" left-arrow @click-left="$router.back()"/>
    <section class="mine"><span>我的排名</span><b>{{ mine ? '#' + field(mine, 'rank') : '--' }}</b>
      <p>{{ mine ? field(mine, 'value_score') + ' 分 · ' + field(mine, 'reviewed_count') + ' 次复核' : '本月暂无已复核日志' }}</p><small>平台贡献观察分
        {{ mine ? field(mine, 'platform_contribution_score') : '--' }}（不计入绩效）</small></section>
    <van-field v-model="period" label="月份" type="month" @change="load"/>
    <section class="list">
      <div v-for="row in rows.slice(0,20)" :key="field(row,'employee_id')" :class="{active:isMine(row)}"><i>{{ field(row, 'rank') }}</i>
        <div><b>{{ field(row, 'employee_name') }}</b><span>{{ field(row, 'department_name') }} · 平台观察 {{
            field(row, 'platform_contribution_score')
          }}</span></div>
        <strong>{{ field(row, 'value_score') }}</strong></div>
    </section>
  </div>
</template>
<script>import api from '@/api/brand';

export default {
  data() {
    return {period: new Date().toISOString().slice(0, 7), rows: []}
  }, computed: {
    mine() {
      return this.rows.find(this.isMine)
    }
  }, created() {
    this.load()
  }, methods: {
    field(r, k) {
      return r[k] !== undefined ? r[k] : r[k.toUpperCase()]
    }, isMine(r) {
      const id = localStorage.getItem('CoreEmployeeId');
      return id ? String(this.field(r, 'employee_id')) === id : this.field(r, 'employee_name') === localStorage.getItem('CoreEmployeeName')
    }, async load() {
      try {
        this.rows = await api.employeeRank(this.period)
      } catch (e) {
        this.$toast.fail(e.message)
      }
    }
  }
};</script>
<style lang="less" scoped>
@import "./brand-page.less";

.mine {
  position: relative;
  padding: .34rem .4rem;
  text-align: center
}

.mine::before {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: .06rem;
  background: #d32f2f;
  content: ""
}

.mine span, .mine p {
  font-size: .26rem;
  color: #777b8e
}

.mine b {
  display: block;
  margin: .08rem;
  color: #d32f2f;
  font-size: .66rem;
  line-height: 1.25
}

.mine p {
  margin: .06rem 0 0
}

.list {
  padding: .04rem 0
}

.list > div {
  display: grid;
  min-height: 1.2rem;
  padding: 0 .28rem;
  grid-template-columns:.72rem minmax(0, 1fr) 1rem;
  align-items: center;
  border-bottom: 1px solid #eceef3
}

.list > div:last-child {
  border-bottom: 0
}

.list i {
  width: .46rem;
  height: .46rem;
  border-radius: 50%;
  color: #777b8e;
  background: #f0f1f5;
  font-size: .25rem;
  font-style: normal;
  line-height: .46rem;
  text-align: center
}

.list > div:nth-child(1) i {
  color: #fff;
  background: #d32f2f
}

.list > div:nth-child(2) i {
  color: #fff;
  background: #ee8b2d
}

.list > div:nth-child(3) i {
  color: #fff;
  background: #8c92a3
}

.list div b, .list div span {
  display: block
}

.list div b {
  overflow: hidden;
  color: #34364a;
  font-size: .31rem;
  text-overflow: ellipsis;
  white-space: nowrap
}

.list div span {
  margin-top: .06rem;
  color: #9295a7;
  font-size: .25rem
}

.list strong {
  text-align: right;
  color: #34364a;
  font-size: .34rem
}

.list .active {
  background: #fff6f6
}

.list .active strong {
  color: #d32f2f
}

.mine small {
  display: block;
  margin-top: .1rem;
  color: #9f6a20;
  font-size: .23rem
}
</style>



// WEBPACK FOOTER //
// src/views/brand/MyRank.vue